import { with1ezpy3gn0rpui as with_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { SavePairAssignmentsMutation1xoyawurksq0m as SavePairAssignmentsMutation } from './schema/SavePairAssignmentsMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instancehwhu2w41uegl as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _NotEmptyList___get_head__impl__zp2swu0zs1qn8pqty as _NotEmptyList___get_head__impl__zp2sw,
  _NotEmptyList___get_tail__impl__3z1zi81rb3cv4yxqpfw as _NotEmptyList___get_tail__impl__3z1zi8,
  NotEmptyList__toList_impl_nbkblo1xb1zjd6musb4 as NotEmptyList__toList_impl_nbkblo,
  NotEmptyList3lrchpxsqrpb2 as NotEmptyList,
  notEmptyListOf1z9dexvzyo0sz as notEmptyListOf,
} from '../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Companion_instance19mvqqhuhhta7 as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { SavePairAssignmentsInput3tgrc8c2zd524 as SavePairAssignmentsInput } from './schema/type/SavePairAssignmentsInput.mjs';
import { PinnedPairInput36po72mbn91ld as PinnedPairInput } from './schema/type/PinnedPairInput.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from './schema/type/PinnedPlayerInput.mjs';
import { PinInput9votjh1m54tp as PinInput } from './schema/type/PinInput.mjs';
import {
  Badge_Default_getInstance1otqjbbvwssaa as Badge_Default_getInstance,
  Badge_Alternate_getInstance1ndnmchouekzy as Badge_Alternate_getInstance,
} from './schema/type/Badge.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_getInstancehzpw8lhng1eb as Companion_getInstance } from './schema/type/AvatarType.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  yield* this.v75(new (SavePairAssignmentsMutation())(toSavePairAssignmentsInput(with_0(command.m2l_1, command.n2l_1))), $completion);
  return Accepted_instance;
}
var SdkSavePairAssignmentsCommandDispatcherClass;
function SdkSavePairAssignmentsCommandDispatcher() {
  if (SdkSavePairAssignmentsCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePairAssignmentsCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePairAssignmentsCommandDispatcherClass = $;
  }
  return SdkSavePairAssignmentsCommandDispatcherClass;
}
function toSavePairAssignmentsInput(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.o2b_1.z2c_1;
  var p0 = _NotEmptyList___get_head__impl__zp2sw(this_0);
  var tmp = toSerializableInput(p0);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = toSerializableInput(item);
      destination.i2(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var tmp$ret$0 = notEmptyListOf(tmp, tmp_4.slice());
  return new (SavePairAssignmentsInput())(_this__u8e3s4.n2b_1, _this__u8e3s4.o2b_1.x2c_1, _this__u8e3s4.o2b_1.y2c_1, NotEmptyList__toList_impl_nbkblo(tmp$ret$0), Companion_instance.c4b(_this__u8e3s4.o2b_1.a2d_1), Companion_instance.c4b(_this__u8e3s4.o2b_1.b2d_1));
}
function toSerializableInput(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.h2c_1;
  var p0 = _NotEmptyList___get_head__impl__zp2sw(this_0);
  var tmp = toSerializableInput_0(p0);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = toSerializableInput_0(item);
      destination.i2(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var tmp$ret$0 = notEmptyListOf(tmp, tmp_4.slice());
  var tmp_5 = NotEmptyList__toList_impl_nbkblo(tmp$ret$0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = _this__u8e3s4.i2c_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().h2(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item_0 = _iterator__ex2g4s_0.r1();
    var tmp$ret$9 = toSerializableInput_1(item_0);
    destination_0.i2(tmp$ret$9);
  }
  return new (PinnedPairInput())(tmp_5, destination_0);
}
function toSerializableInput_0(_this__u8e3s4) {
  var tmp = Companion_instance.c4b(toSerializable(_this__u8e3s4.k2c_1.r2b_1));
  var tmp_0 = Companion_instance.c4b(_this__u8e3s4.k2c_1.w2b_1);
  var tmp_1 = Companion_instance;
  var tmp0_safe_receiver = _this__u8e3s4.k2c_1.x2b_1;
  var tmp_2 = tmp_1.c4b(tmp0_safe_receiver == null ? null : toSerializable_0(tmp0_safe_receiver));
  var tmp_3 = toList(_this__u8e3s4.k2c_1.y2b_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.l2c_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = toSerializableInput_1(item);
    destination.i2(tmp$ret$2);
  }
  return new (PinnedPlayerInput())(_this__u8e3s4.k2c_1.q2b_1, _this__u8e3s4.k2c_1.s2b_1, _this__u8e3s4.k2c_1.t2b_1, tmp, _this__u8e3s4.k2c_1.u2b_1, _this__u8e3s4.k2c_1.v2b_1, tmp_0, tmp_2, tmp_3, destination);
}
function toSerializableInput_1(_this__u8e3s4) {
  var tmp0_id = _this__u8e3s4.e2e_1;
  var tmp1_name = Companion_instance.c4b(_this__u8e3s4.f2e_1);
  var tmp2_icon = Companion_instance.c4b(_this__u8e3s4.g2e_1);
  return new (PinInput())(tmp0_id, tmp2_icon, tmp1_name);
}
function toSerializable(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 0:
      tmp = Badge_Default_getInstance();
      break;
    case 1:
      tmp = Badge_Alternate_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toSerializable_0(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var it = _this__u8e3s4.v1_1;
  return Companion_getInstance().q70(it);
}
//region block: exports
export {
  SdkSavePairAssignmentsCommandDispatcher as SdkSavePairAssignmentsCommandDispatcher3ocpuomh8jp9i,
  toSerializable as toSerializable3fb4aia8ysz5b,
  perform as perform36hp3lo09iydn,
};
//endregion

//# sourceMappingURL=SdkPairAssignmentDocumentSave.mjs.map
